import { useState } from 'react';
import axios from 'axios';

function ContactUs() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
    setIsLoading(true);

    try {
      const response = await axios.post('/your-api-endpoint', { name, email, message });

      alert('Thank you for contacting us!');
      
      // Clear inputs
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error(error);
      alert('Something went wrong. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="contact" className="bg-[#D7EEFA] py-16 px-4">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Need assistance? Contact us</h2>
        <p className="text-gray-600 mb-10">
          We're here to help. Reach out with any questions, feedback, or suggestions, and we’ll get back to you promptly.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col space-y-6">
          <input 
            type="text" 
            placeholder="Name" 
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="p-4 rounded-md border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#00A6FB]"
            required
          />
          <input 
            type="email" 
            placeholder="Email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="p-4 rounded-md border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#00A6FB]"
            required
          />
          <textarea 
            placeholder="Message" 
            rows="5"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="p-4 rounded-md border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#00A6FB]"
            required
          ></textarea>

          <div className="text-right">
            <button 
              type="submit" 
              className="bg-[#00A6FB] hover:bg-[#00A6FB] text-white font-semibold py-3 px-8 rounded-md inline-flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center">
                  <svg className="animate-spin h-5 w-5 mr-2 text-white" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  Sending...
                </div>
              ) : (
                <>
                  Send <span className="ml-2">➔</span>
                </>
              )}
            </button>
          </div>
        </form>
        <div className="mt-12 text-left bg-white p-6 rounded-md shadow-md text-gray-800 space-y-4">
  
  <p>
    <strong>Call us:</strong>{" "}
    <a href="tel:+918983070225" className="text-[#00A6FB] hover:underline">
      +91 8983 0702 25
    </a>
  </p>
  <p>
    <strong>Email support:</strong>{" "}
    <a href="mailto:support@membermeld.com" className="text-[#00A6FB] hover:underline">
      support@membermeld.com
    </a>
  </p>
  <p>
    <strong>Stay connected:</strong> Reach out anytime via{" "}
    <a
      href="https://wa.me/918983070225"
      target="_blank"
      rel="noopener noreferrer"
      className="text-green-600 hover:underline"
    >
      WhatsApp
    </a>
    , SMS, or Phone — we’re always happy to help.
  </p>
</div>

      </div>
    </section>
  );
}

export default ContactUs;
